(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["br-autosuggest-recommendations"] && !Shopify.designMode) return;
  try {
    let retries = 0;
  let recommendationsStatus = 0;

  (function init() {
    if (typeof brweb === "undefined") {
      if (retries++ < 50) setTimeout(init, 100);
      return;
    }

    const container = document.querySelector(".br-autosuggest-recs");
    if (!container) return;

    const recommendationId = container.dataset.recommendationId;
    const recommendationSize = parseInt(container.dataset.recommendationSize, 10) || 8;
    const placeholderUrl = container.dataset.placeholderImage;
    const moneyFormat = container.dataset.moneyFormat;
    const errorMessage = container.dataset.errorMessage;
    const noResultsMessage = container.dataset.noResultsMessage;
    const resultsForTemplate = container.dataset.resultsForTemplate;
    const noResultsForTemplate = container.dataset.noResultsForTemplate;
    const searchUrl = container.dataset.searchUrl;

    const defaultPanel = container.querySelector("[data-br-default-panel]");
    const dropdownMount = container.querySelector("[data-br-dropdown-mount]");
    const noResultsEl = container.querySelector("[data-br-no-results]");
    const loadingEl = container.querySelector("[data-br-loading]");

    function getCurrentSearchTerm() {
      // ".search-input" is the single modal input search-bar.js keeps mirrored
      // to whichever header bar input (mobile or desktop) the shopper is
      // actually typing into — check it first. Multiple ".search-bar__input"
      // elements can exist at once (desktop + mobile variants), so falling
      // back to a plain querySelector there risks reading the wrong (empty)
      // one.
      const modalInput = /** @type {HTMLInputElement | null} */ (document.querySelector(".search-input"));
      if (modalInput?.value.trim()) return modalInput.value.trim();

      const barInputs = /** @type {HTMLInputElement[]} */ (Array.from(document.querySelectorAll(".search-bar__input")));
      const activeBarInput = barInputs.find(function (el) { return el.value.trim(); });
      return activeBarInput ? activeBarInput.value.trim() : "";
    }

    function escapeHtml(text) {
      const div = document.createElement("div");
      div.textContent = text;
      return div.innerHTML;
    }

    // Bolds and darkens the first case-insensitive occurrence of `term`
    // inside `title`, leaving the rest of the title untouched.
    function highlightTerm(title, term) {
      if (!term) return escapeHtml(title);

      const index = title.toLowerCase().indexOf(term.toLowerCase());
      if (index === -1) return escapeHtml(title);

      const before = title.slice(0, index);
      const match = title.slice(index, index + term.length);
      const after = title.slice(index + term.length);

      return (
        escapeHtml(before) +
        '<span style="font-weight: 700; color: var(--color-foreground);">' +
        escapeHtml(match) +
        "</span>" +
        escapeHtml(after)
      );
    }

    function renderSearchTerm(list) {
      const term = getCurrentSearchTerm();
      if (!term) return;

      const searchTermEl = document.createElement("p");
      searchTermEl.className = "br-autosuggest__search-term";
      searchTermEl.setAttribute("data-search-term", "");
      searchTermEl.textContent = resultsForTemplate.replace("__TERM__", term);
      list.appendChild(searchTermEl);
    }

    // Bloomreach's own autosuggest dropdown (real search results, as opposed
    // to the top-sellers recs panel above) renders its own
    // ".br-autosuggest__products" markup outside our control. Watch for it
    // and prepend the same search-term line whenever it (re)appears.
    // Excludes only our own top-sellers block (data-search-results) — once
    // relocated, BR's real dropdown lives inside this same container too,
    // so excluding by ".br-autosuggest-recs" would wrongly skip it.
    function injectDropdownSearchTerm() {
      const term = getCurrentSearchTerm();
      const text = term ? resultsForTemplate.replace("__TERM__", term) : "";

      document.querySelectorAll(".br-autosuggest__products").forEach(function (productsEl) {
        if (productsEl.closest("[data-search-results]")) return;

        const existing = productsEl.querySelector(":scope > [data-search-term]");

        if (!term) {
          if (existing) existing.remove();
          return;
        }

        if (existing) {
          if (existing.textContent !== text) existing.textContent = text;
          return;
        }

        const searchTermEl = document.createElement("p");
        searchTermEl.className = "br-autosuggest__search-term";
        searchTermEl.setAttribute("data-search-term", "");
        searchTermEl.textContent = text;
        productsEl.insertBefore(searchTermEl, productsEl.firstChild);
      });
    }

    // Highlights the matched term inside each BR-rendered product card's
    // title. Each <br-product-card> uses a declarative shadow root, so its
    // title lives outside the light DOM our MutationObserver watches — this
    // only needs to run when the card itself is (re)added, which is a
    // light-DOM mutation we do observe.
    function highlightExternalProductTitles() {
      const term = getCurrentSearchTerm();

      document.querySelectorAll("br-product-card").forEach(function (card) {
        const root = card.shadowRoot;
        const titleEl = root?.querySelector(".br-product-card__title");
        if (!titleEl) return;

        const highlighted = highlightTerm(titleEl.textContent || "", term);
        if (titleEl.innerHTML !== highlighted) titleEl.innerHTML = highlighted;
      });
    }

    // Bloomreach mounts its real autosuggest dropdown wherever it likes
    // (typically appended to <body>, positioned outside this panel). Move
    // the actual node — not a clone — into our own container so its
    // internal listeners/tracking keep working, and we get one persistent
    // panel that never has to close to reveal real results.
    function relocateBrDropdown() {
      if (!dropdownMount) return;

      const dropdown = document.querySelector(".br-autosuggest--dropdown");
      if (!dropdown || dropdownMount.contains(dropdown)) return;

      dropdownMount.innerHTML = "";
      dropdownMount.appendChild(dropdown);
    }

    // Sets both the `hidden` attribute and an explicit inline `display`.
    // ".br-autosuggest__panel" (shared with BR's own relocated markup) is
    // styled with an unscoped "display: flex/grid" rule whose specificity
    // beats the browser's default "[hidden] { display: none }" rule, so
    // toggling `hidden` alone silently does nothing on the default panel —
    // the inline style is what actually wins here.
    function setPanelHidden(el, isHidden) {
      if (!el) return;
      el.hidden = isHidden;
      el.style.display = isHidden ? "none" : "";
    }

    function showDefaultPanel() {
      setPanelHidden(defaultPanel, false);
      setPanelHidden(dropdownMount, true);
      setPanelHidden(noResultsEl, true);
      setPanelHidden(loadingEl, true);
    }

    function showDropdownResults() {
      setPanelHidden(defaultPanel, true);
      setPanelHidden(dropdownMount, false);
      setPanelHidden(noResultsEl, true);
      setPanelHidden(loadingEl, true);
    }

    // Interim state while we don't yet know whether BR will mount real
    // results or nothing at all for the current term. Showing a neutral
    // loading line here (rather than the recs panel) avoids an irrelevant
    // "top sellers" flash between two unrelated committed states.
    function showLoading() {
      setPanelHidden(defaultPanel, true);
      setPanelHidden(dropdownMount, true);
      setPanelHidden(noResultsEl, true);
      setPanelHidden(loadingEl, false);
    }

    function showNoResults(term) {
      setPanelHidden(defaultPanel, true);
      setPanelHidden(dropdownMount, true);
      setPanelHidden(noResultsEl, false);
      setPanelHidden(loadingEl, true);
      if (noResultsEl && term) {
        // Assigning textContent always triggers a childList mutation, even
        // when the value is unchanged — since our MutationObserver watches
        // childList on document.body, an unconditional assignment here
        // re-triggers updatePanelState() -> showNoResults() forever.
        const text = noResultsForTemplate
          ? noResultsForTemplate.replace("__TERM__", term)
          : noResultsMessage;
        if (noResultsEl.textContent !== text) noResultsEl.textContent = text;
      }
    }

    // Clicking a query suggestion, category tag, product link, or "show all"
    // sets the input's value as part of BR's own navigation flow, right
    // before it redirects the whole page to the search results. That value
    // change fires our input listener with a brand-new, unconfirmed term
    // while BR is mid-teardown — without this flag we'd transiently flash
    // loading/no-results for a term that's actually fine, it's just about
    // to leave the page. Once one of these is clicked there's no longer any
    // point reacting to further state changes.
    //
    // Set on mousedown, not click: BR's own click handler is bound directly
    // to these elements and fires during the "at target" phase, which
    // completes before a click bound on our ancestor container ever gets to
    // bubble — by then BR has already changed the input value. mousedown
    // always precedes that click, so it reliably wins the race.
    let isNavigatingAway = false;

    let noMatchTimer = null;
    let noMatchTerm = null;
    // Term that the fallback timer has already confirmed has zero matches.
    // Without this, showNoResults() below triggers our own MutationObserver
    // (it changes the DOM), which re-enters updatePanelState() while the
    // mount is still empty — that would treat the freshly-confirmed
    // no-results state as "still pending" and immediately flip back to the
    // default panel, forever, since every showNoResults() call re-triggers
    // the same loop.
    let noMatchConfirmedTerm = null;

    function clearNoMatchTimer() {
      if (noMatchTimer) {
        clearTimeout(noMatchTimer);
        noMatchTimer = null;
      }
      noMatchTerm = null;
    }

    // Bloomreach doesn't always mount ".br-autosuggest--dropdown" at all for
    // a query with zero matches anywhere (no suggestions, no products) — so
    // waiting on a DOM mutation to detect "no results" never fires. Fall
    // back to showing our own no-results message once things have gone
    // quiet for a bit with nothing resolved.
    //
    // This is a genuine debounce, not a one-shot delay: it's called again on
    // every mutation while results are still pending (grid created but not
    // yet populated, cards trickling in one at a time, etc.), and each call
    // pushes the verdict back out. A one-shot timer from the FIRST pending
    // detection would fire mid-render for anything slower than 800ms end to
    // end, showing "no results" a beat before real cards land.
    function scheduleNoMatchFallback(term) {
      clearNoMatchTimer();
      noMatchTerm = term;
      noMatchTimer = setTimeout(function () {
        noMatchTimer = null;
        if (getCurrentSearchTerm() !== term) return;
        const grid = dropdownMount && dropdownMount.querySelector(".br-products__grid");
        if (grid && grid.children.length > 0) return;
        noMatchConfirmedTerm = term;
        showNoResults(term);
      }, 800);
    }

    // Decides which of the four states the panel should be in. While the
    // user is typing but BR hasn't mounted (or has just emptied) its
    // dropdown for this term yet, a neutral loading state is shown — the
    // drawer must never be left showing nothing while we wait to find out
    // whether that's "no results" or "results still loading", and it must
    // not flash the unrelated recs panel in the meantime either.
    // Bloomreach's autosuggest API requires a minimum of 3 characters —
    // shorter terms never get queried, so there's nothing to load/wait on.
    const MIN_QUERY_LENGTH = 3;

    function updatePanelState() {
      if (isNavigatingAway) return;

      const term = getCurrentSearchTerm();

      if (!term || term.length < MIN_QUERY_LENGTH) {
        clearNoMatchTimer();
        noMatchConfirmedTerm = null;
        showDefaultPanel();
        return;
      }

      // BR can build its dropdown in stages — the outer wrapper may land in
      // one mutation with ".br-products__grid" only appearing (and filling
      // in) in a later one. Checking dropdownMount.children.length alone
      // treats that half-built wrapper as "confirmed content", which used
      // to fire showNoResults() instantly for a query that genuinely has
      // matches, a beat before they actually render. Only the presence of
      // populated ".br-products__grid" counts as "has results" — everything
      // else (mount empty OR mount present but not yet populated) goes
      // through the same pending/settle path.
      const grid = dropdownMount && dropdownMount.querySelector(".br-products__grid");
      const hasResults = Boolean(grid && grid.children.length > 0);

      if (!hasResults) {
        // BR can go quiet for a term it previously had results for (e.g. it
        // rebuilds its dropdown in stages, or dismisses its own DOM after a
        // stray click) — but that's never a reason to close the whole
        // drawer out from under the shopper. Treat it the same as any other
        // still-settling/empty state: show loading, then fall back to our
        // own no-results message if nothing shows up.
        if (noMatchConfirmedTerm === term) {
          showNoResults(term);
          return;
        }
        scheduleNoMatchFallback(term);
        showLoading();
        return;
      }

      noMatchConfirmedTerm = null;

      clearNoMatchTimer();

      showDropdownResults();
    }

    new MutationObserver(function () {
      relocateBrDropdown();
      updatePanelState();
      injectDropdownSearchTerm();
      highlightExternalProductTitles();
    }).observe(document.body, { childList: true, subtree: true });

    // Revert to the default panel the moment the field is cleared, without
    // waiting on a DOM mutation from BR.
    document.addEventListener("input", function (event) {
      if (event.target.matches(".search-input, .search-bar__input")) {
        updatePanelState();
      }
    });

    // Bloomreach's widget has its own "click outside my dropdown" listener
    // that dismisses (removes) its DOM based on containment against its OWN
    // node — not ours. Any click on whitespace within our larger panel
    // (padding, gaps between sections) is legitimately "outside" BR's
    // relocated node from BR's point of view, so it self-destructs even
    // though the user never left this panel. Our code then reads the empty
    // mount as a genuine zero-results response.
    //
    // preventDefault() alone can't stop this — it only cancels the browser's
    // default action (e.g. focus shift), not other listeners reacting to
    // the same event. To actually block BR's handler we intercept in the
    // capture phase on document, which always runs before any bubble-phase
    // listener regardless of script load order, and stop the event there.
    // Real interactive elements (product links, help links) are excluded so
    // clicking/navigating them still works normally.
    document.addEventListener(
      "mousedown",
      function (event) {
        const target = /** @type {Element} */ (event.target);
        if (!container.contains(target)) return;
        // Third-party widgets (e.g. the Clarity "ask anything" panel) can be
        // injected inside this container. They own their own click handling,
        // so never intercept clicks within them. Clicking one takes the
        // shopper into a different experience, so also stop our own
        // MutationObserver-driven panel state from reacting to whatever DOM
        // churn that widget causes next (which otherwise gets misread as
        // "no results" and overwrites the results the shopper was looking
        // at right before the dialog finishes closing).
        if (target.closest("[class*='cui-']")) {
          isNavigatingAway = true;
          return;
        }
        if (target.closest("a, button, input, [role='button']")) {
          isNavigatingAway = true;
          return;
        }
        event.preventDefault();
        event.stopPropagation();
      },
      { capture: true },
    );

    // Clicking into the Clarity widget (e.g. "Ask anything", suggested
    // prompts) takes the shopper into a different experience entirely, so
    // the search modal behind it should close rather than stay open.
    // Capture phase, same as the mousedown listener above: the widget's own
    // click handler may call stopPropagation(), which would otherwise stop
    // this from ever reaching document in the bubble phase.
    document.addEventListener(
      "click",
      function (event) {
        const target = /** @type {Element} */ (event.target);
        if (!container.contains(target)) return;
        if (!target.closest("[class*='cui-']")) return;

        const dialog = container.closest("dialog-component");
        if (dialog && typeof dialog.closeDialog === "function") {
          dialog.closeDialog();
        }
      },
      { capture: true },
    );

    // Bloomreach's own widget handles Enter itself (typically clearing its
    // dropdown and calling preventDefault, without submitting anywhere) —
    // it doesn't know about our search results page. Left alone, that
    // dropdown teardown reads as "BR self-dismissed" above and closes the
    // whole modal instead of going anywhere. Intercept in the capture phase
    // so we run before BR's own handler: mark this as a deliberate
    // navigation (so the self-dismiss guard doesn't fire) and drive the
    // navigation ourselves, since we can't rely on BR's widget doing it.
    document.addEventListener(
      "keydown",
      function (event) {
        if (event.key !== "Enter") return;
        const target = /** @type {Element} */ (event.target);
        if (!target.matches(".search-input, .search-bar__input")) return;

        isNavigatingAway = true;

        if (!searchUrl) return;
        const term = getCurrentSearchTerm();
        if (!term) return;

        event.preventDefault();
        const url = new URL(searchUrl, location.origin);
        url.searchParams.set("q", term);
        window.location.href = url.toString();
      },
      { capture: true },
    );

    if (!recommendationId) return;

    let recommendationAttempts = 0;

    function showError() {
      const list = document.querySelector("[data-br-recommendations]");
      if (!list) return;
      list.innerHTML = "";
      const message = document.createElement("p");
      message.className = "br-recommendations__error";
      message.textContent = errorMessage;
      list.appendChild(message);
    }

    function shopifyResizedUrl(url, width) {
      if (!url) return url;
      const separator = url.includes("?") ? "&" : "?";
      return url + separator + "width=" + width;
    }

    function formatPrice(price) {
      if (price == null) return null;
      const amount = parseFloat(price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (moneyFormat) return moneyFormat.replace('{{amount}}', amount);
      return '$' + amount;
    }

    function onRecommendationsLoaded(data) {
      if (recommendationsStatus === "TIMED_OUT") return;
      recommendationsStatus = "LOADED";

      const list = document.querySelector("[data-br-recommendations]");
      if (!list) return;

      if (!data || data.length === 0) {
        showError();
        return;
      }

      list.innerHTML = "";
      renderSearchTerm(list);

      const template = document.getElementById("br-autosuggest-product-template");
      const itemIds = data.map(function(item) { return item.item_id; });

      for (const item of data) {
        const card = template.content.cloneNode(true).firstElementChild;

        const link = card.querySelector(".br-product-card__link");
        const img = card.querySelector(".br-product-card__image img");
        const title = card.querySelector(".br-product-card__title");
        const priceEl = card.querySelector(".br-product-card__price");

        if (link) link.href = item.url;
        if (img) {
          img.src = shopifyResizedUrl(item.thumb_image || placeholderUrl, 300);
          img.alt = item.title;
        }
        if (title) title.innerHTML = highlightTerm(item.title, getCurrentSearchTerm());

        const displayPrice = item.formattedPrice || item.formattedSalePrice || formatPrice(item.price);
        if (priceEl && displayPrice) priceEl.textContent = displayPrice;

        list.appendChild(card);
      }

      brweb.track("recommendation", {
        action: "show",
        item_ids: itemIds,
        recommendation_id: recommendationId,
      });
    }

    function requestRecommendations() {
      recommendationAttempts++;
      recommendationsStatus = "PENDING";

      brweb.getRecommendation({
        recommendationId: recommendationId,
        size: recommendationSize,
        callback: onRecommendationsLoaded,
        fillWithRandom: true,
        catalogFilter: [],
        catalogAttributesWhitelist: ["title", "url", "thumb_image", "price", "sale_price"],
      });

      setTimeout(function() {
        if (recommendationsStatus === "PENDING") {
          brweb.track("recommendation", {
            action: "timeout",
            recommendation_id: recommendationId,
          });

          if (recommendationAttempts < 2) {
            requestRecommendations();
          } else {
            recommendationsStatus = "TIMED_OUT";
            showError();
          }
        }
      }, 5000);
    }

    requestRecommendations();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    (function () {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) return;

    const overlay = document.createElement('div');
    overlay.className = 'cart-drawer__overlay';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);

    cartDrawer.addEventListener('dialog:open', () => {
      const header = document.querySelector('header-component');
      const offset = header ? header.getBoundingClientRect().bottom : 0;
      document.documentElement.style.setProperty('--cart-drawer-header-offset', `${offset}px`);
      overlay.classList.add('cart-drawer__overlay--visible');
    });

    cartDrawer.addEventListener('dialog:close', () => {
      overlay.classList.remove('cart-drawer__overlay--visible');
      // Swym adds swym-modal-active to body when any modal opens; remove it on our close
      // since Swym doesn't reliably clean it up when it's our dialog that triggered it.
      document.body.classList.remove('swym-modal-active');
    });

    const dialog = cartDrawer.querySelector('dialog');
    const itemCountEl = cartDrawer.querySelector('.cart-drawer__item-count');

    // When component-cart-items.js shows the empty template optimistically
    // (before the cart:update AJAX response arrives), immediately sync the
    // cart-drawer--empty class so the item count hides and layout stabilises
    // in one frame rather than shifting a moment later.
    const inner = cartDrawer.querySelector('[data-hydration-key="cart-drawer-inner"]');
    if (inner && dialog) {
      const emptyObserver = new MutationObserver(() => {
        const isEmpty = !!inner.querySelector('.cart-drawer__heading--empty');
        dialog.classList.toggle('cart-drawer--empty', isEmpty);
      });
      emptyObserver.observe(inner, { childList: true, subtree: true });
    }

    document.addEventListener('cart:update', (event) => {
      const itemCount = event.detail?.data?.itemCount ?? 0;

      if (dialog) {
        dialog.classList.toggle('cart-drawer--empty', itemCount === 0);
      }

      if (itemCountEl) {
        const template = itemCount === 1 ? itemCountEl.dataset.countOne : itemCountEl.dataset.countOther;
        if (template) {
          itemCountEl.textContent = template.replace(/\d+/, itemCount);
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
